import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { CustomButton, TextField } from '../../../v2/MUI_custom_component';
import GlassModal from '../../../v2/MUI_custom_component/Modal/GlassModal';

const EditPOModal = ({ 
    open, 
    onClose, 
    poDetails, 
    selectedSupplierData,
    onSave,
    loading = false 
}) => {
    const [editQuantity, setEditQuantity] = useState('');
    const [editUserPONumber, setEditUserPONumber] = useState('');

    // Initialize form fields when modal opens or poDetails changes
    useEffect(() => {
        if (open && poDetails) {
            setEditQuantity(poDetails.quantity_info?.[0]?.value || '');
            setEditUserPONumber(poDetails.user_po_number || '');
        }
    }, [open, poDetails]);

    const handleSave = () => {
        if (onSave) {
            onSave({
                quantity: editQuantity,
                userPONumber: editUserPONumber,
                poDetails
            });
        }
    };

    const handleClose = () => {
        // Reset form fields
        setEditQuantity('');
        setEditUserPONumber('');
        onClose();
    };

    return (
        <GlassModal
            open={open}
            onClose={handleClose}
            title="Edit Purchase Orders"
            scrollable={true}
            maxWidth="600px"
            zIndex={2}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                        <Typography variant="labelM" sx={{ color: '#666' }}>
                            SAP Code*
                        </Typography>
                        <Typography variant="Body1">
                            {selectedSupplierData && selectedSupplierData.entity_info[0]?.external_system_code}
                        </Typography>
                    </Box>
                    
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                        <Typography variant="labelM" sx={{ color: '#666' }}>
                            Quantity (Ton)
                        </Typography>
                        <TextField
                            variant="standard"
                            size="small"
                            type="number"
                            value={editQuantity}
                            onChange={(e) => setEditQuantity(e.target.value)}
                            placeholder="Enter quantity"
                            fullWidth
                        />
                    </Box>
                    
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                        <Typography variant="labelM" sx={{ color: '#666' }}>
                            User PO No.
                        </Typography>
                        <TextField
                            variant="standard"
                            size="small"
                            value={editUserPONumber}
                            onChange={(e) => setEditUserPONumber(e.target.value)}
                            placeholder="Enter PO number"
                            fullWidth
                        />
                    </Box>
                </Box>
                
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                    <Typography variant="h2">
                        Are you sure you want to update PO?
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#666' }}>
                        Your purchase order will be updated.
                    </Typography>
                </Box>
                
                <Box sx={{
                    display: 'flex',
                    gap: 1,
                }}>
                    <CustomButton
                        label="No"
                        variant="outlined"
                        color="primary"
                        onClick={handleClose}
                        sx={{ 
                            width: '50%',
                        }}
                    />
                    <CustomButton
                        label="Yes"
                        variant="filled"
                        color="primary"
                        loading={loading}
                        onClick={handleSave}
                        sx={{ 
                            width: '50%',
                        }}
                    />
                </Box>
            </Box>
        </GlassModal>
    );
};

export default EditPOModal;